import { TextField } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useStores } from '@trivie/core'
import { Button } from '@trivie/ui-web/components/button'
import { Text } from '@trivie/ui-web/components/text'

export const TestLogin = observer(() => {
  const { manageUserStore } = useStores()
  const { login, authenticated } = manageUserStore

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [accessCode, setAccessCode] = useState('')
  const history = useHistory()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100vw',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Text text="Username" />
      <TextField
        variant="standard"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />

      <Text text="Password" style={{ marginTop: 20 }} />
      <TextField
        variant="standard"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <Text text="Access Code" style={{ marginTop: 20 }} />
      <TextField
        variant="standard"
        value={accessCode}
        onChange={(e) => setAccessCode(e.target.value)}
      />

      <Button
        text="Submit"
        onClick={() =>
          login({ username, password }, accessCode, () => history.push('/insights/knowledge'))
        }
        style={{ marginTop: 20 }}
      />
    </div>
  )
})
